<div
  class="row"
  [ngClass]="{ hide: message == null, show: message != null }"
  style=""
>
  <div class="col-sm-6 offset-sm-3">
    <div
      *ngIf="message"
      [ngClass]="{
        alert: message,
        'alert-success': message.type === 'success',
        'alert-danger': message.type === 'error',
        'alert-info': message.type === 'info',
      }"
    >
      {{ message.text }}
    </div>
  </div>
</div>
<p-toast position="top-center" [baseZIndex]="5000"></p-toast>

<p-toast
  position="top-center"
  key="confirmToat"
  (onClose)="onReject()"
  [baseZIndex]="5000"
>
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center">
        <i
          class="pi pi-exclamation-triangle text-danger"
          style="font-size: 3em"
        ></i>
        <h3>{{ message.summary }}</h3>
        <p>{{ message.detail }}</p>
      </div>
      <div class="row w-100 m-0 justify-content-center">
        <div class="col-auto mr-2">
          <button
            type="button"
            pButton
            (click)="onConfirm()"
            class="btn btn-primary"
          >
            Yes
          </button>
        </div>
        <div class="col-auto">
          <button
            type="button"
            pButton
            (click)="onReject()"
            class="btn btn-secondary"
          >
            No
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
